import { type MutationHookOptions, useMutation } from "@apollo/client";
import { EnableOrganizationUserMutation } from "../graphql/mutations";
import type {
  EnableOrganizationUserMutationType,
  EnableOrganizationUserMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useEnableOrganizationUserMutation = (
  options?: MutationHookOptions<
    EnableOrganizationUserMutationType,
    EnableOrganizationUserMutationVariablesType
  >
) => {
  return useMutation<
    EnableOrganizationUserMutationType,
    EnableOrganizationUserMutationVariablesType
  >(EnableOrganizationUserMutation, options);
};
